module.exports = __webpack_public_path__ + "static/img/logo-best-practice-team.3ff1284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-best-practice-team.png
// module id = sT0M
// module chunks = 1